// The API returns dates as DATE_ATOM strings (e.g. 2024-05-01T00:00:00+02:00); shown in the device's local time.
const parts = (value: string | number | Date) => {
  const date = new Date(value)
  if (isNaN(date.getTime())) return null
  const pad = (n: number) => String(n).padStart(2, '0')
  return { d: pad(date.getDate()), m: pad(date.getMonth() + 1), y: String(date.getFullYear()) }
}

/** DD-MM-YYYY, or '' for a missing/invalid value. */
export const formatDate = (value: string | number | Date) => {
  const p = parts(value)
  return p ? `${p.d}-${p.m}-${p.y}` : ''
}

/** YYYY-MM-DD, the value format of <input type="date">. */
export const toInputDate = (value: string | number | Date) => {
  const p = parts(value)
  return p ? `${p.y}-${p.m}-${p.d}` : ''
}

const monthFormat = new Intl.DateTimeFormat('nl', { month: 'long' })

/** Dutch month name for a 1-based month, e.g. 5 → "mei". */
export const monthName = (month: number) => monthFormat.format(new Date(2000, month - 1, 1))
